import {
  createFormState,
  hasNumber,
  hasLength,
  numberGreaterThanOrEqualTo,
  numberGreaterThan,
} from 'redux-freeform';

const drawerHistoryIndexFiltersFormConfig = {
  id: {},
  startDate: {
    constraints: [hasLength(0, 8)],
    validators: [hasLength(8, 8)],
  },
  endDate: {
    constraints: [hasLength(0, 8)],
    validators: [hasLength(8, 8)],
  },
  maxAmount: {
    constraints: [hasNumber()],
    validators: [hasNumber(), numberGreaterThan(0)],
  },
  minAmount: {
    constraints: [hasNumber()],
    validators: [hasNumber(), numberGreaterThanOrEqualTo(0)],
  },
  agency: {},
  type: {},
  location: { defaultValue: 'all' },
  terminal: { defaultValue: 'all' },
  user: {},
};

export const { reducer, mapStateToProps, mapDispatchToProps } = createFormState(
  drawerHistoryIndexFiltersFormConfig,
);
